import React, { Component } from 'react';
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalHeader, ModalFooter, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import { getVmProviderConfigs, deleteVmProviderConfig } from "../../actions/actionVmProvider";

class VmProviderConfig extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            filterId: null
        };

        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteVmProviderAction = this.deleteVmProviderAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount() {
        this.props.getVmProviderConfigs();
    }

    deleteConfirm(VmProviderConfigId, VmProviderName) {
        this.setState(
            {
                modal: !this.state.modal,
                VmProviderConfigId: VmProviderConfigId,
                VmProviderName: VmProviderName,
            });
    }

    cancelDelete() {
        this.setState({ modal: !this.state.modal });
    }

    deleteVmProviderAction() {
        this.props.deleteVmProviderConfig({ vm_provider_config_id: this.state.VmProviderConfigId, vm_provider_name: this.state.VmProviderName }).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess() {
        const { deleteVmProviderError } = this.props;
        if (deleteVmProviderError) {
            NotificationManager.error(deleteVmProviderError, "Delete VM Provider Config Failed", 3000);
        } else {
            NotificationManager.success("Successfully Deleted VM Provider Config", "Delete VM Provider Config", 3000);
            this.setState({ modal: false });
            this.props.getVmProviderConfigs();
        }
    }

    handleDeleteError() {
        const { deleteVmProviderError } = this.props;
        if (deleteVmProviderError) {
            NotificationManager.error(deleteVmProviderError, "Failed to Delete VM Provider Config", 3000);
            this.props.history.push("/vm_provider");
        } else {
            NotificationManager.error("Failed to Delete VM Provider Config", "Delete VM Provider Config", 3000);
            this.props.history.push("/vm_provider");
        }
    }

    render() {
        if (this.props.getVmProviderLoading) {
            return (<div> <LoadingSpinner /></div>);
        }

        const { vm_provider_configs } = this.props;

        const tableColumns = [
            {
                type: "text",
                name: "Name",
                accessor: "vm_provider_config_name",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Provider",
                accessor: "vm_provider_display_name",
                filterable: true,
                sortable: true,
            },
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/view_vm_provider/${item.vm_provider_config_id}`);
                    break;

                case "edit":
                    this.props.history.push(`/update_vm_provider/${item.vm_provider_config_id}`);
                    break;

                case "delete":
                    this.deleteConfirm(item.vm_provider_config_id, item.vm_provider_name);
                    break;
            }
        }

        return (
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <div className="title-head">
                                    <i className="fa fa-cube"></i> <strong>VM Provider Configurations</strong></div>
                                <Link className="pull-right add-btn" to={{ pathname: "/create_vm_provider" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                        Add
                                    </button>
                                </Link>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="vm_provider"
                                    data={vm_provider_configs}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this config?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm"
                            className="cancel-button"
                            color=" basic">Close</Button>
                        <Button onClick={this.deleteVmProviderAction}
                            className="delete-button"
                            size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default connect(state => ({
    vm_provider_configs: state.vm_provider.vm_provider_configs || [],
    getVmProviderLoading: state.vm_provider.getVmProviderLoading || false,
    getVmProviderErrorMessage: state.vm_provider.getVmProviderErrorMessage || false,
    getVmProviderError: state.vm_provider.getVmProviderError || null,
    deleteVmProviderError: state.vm_provider.deleteVmProviderError || null,
    deletedVmProvider: state.vm_provider.deletedVmProvider || null,
    deleteVmProviderLoading: state.vm_provider.deletVmeProviderLoading || null,
    pages: { pageSize: state.vm_provider.pageSize, pageNo: state.vm_provider.pageNo },
}),
    dispatch => ({
        getVmProviderConfigs: () => dispatch(getVmProviderConfigs()),
        deleteVmProviderConfig: (data) => dispatch(deleteVmProviderConfig(data)),
        setPageInfo: (data) => dispatch(setProviderPageInfo(data)),
    }))(VmProviderConfig);
